import CancelReasonsComponent from "../../../../components/partner/Settings/cancel-reasons/cancelReasons";

export default function CancelReasons() {
  return <CancelReasonsComponent />;
}
